import { useIntl } from 'react-intl';

function useLocale() {
  const intl = useIntl();

  return intl.locale;
}

export default useLocale;
